import { render } from "./j-confirm.vue?vue&type=template&id=1b7fc2d8&scoped=true"
import script from "./j-confirm.vue?vue&type=script&lang=js"
export * from "./j-confirm.vue?vue&type=script&lang=js"

import "./j-confirm.vue?vue&type=style&index=0&id=1b7fc2d8&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7fc2d8"]])

export default __exports__